import { IReviewServices } from './review.types';
import { http } from '@/shared/https'

export class ReviewService implements IReviewServices {
    /** method to get the review template from db*/
    getReviewTemplate(id: number) {
        return http.get(`api/Review/GetTemplate/${id}`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data.Templates.reduce((obj: any, tmpl: any) => {
                    obj[tmpl.Key] = tmpl.Value;
                    return obj;
                }, {});
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }

    /** method to get the review categories */
    getCategories(id: number, lang: string, entity: string) {
        return http.get(`api/ReviewExternal/Categories/${entity}/${id}/language/${lang}`)
            .then((resp: any) => {
                if (resp && resp.data && resp.data.Result === 'OK') {
                    return resp.data.Record;
                } else {
                    return [];
                }
            })
    }

    /** method to get the review categories from db*/
    getReviewData(payload: any): any {
        return http.get(`api/ReviewExternal/${payload.entity}/${payload.reviewerId}/${payload.applicationId}/${payload.language}`)
            .then((resp: any) => {
                return resp.data;
            })
            .catch(e => {
                return null;
            });
    }

    getReportData(id: number, entity: string): any {
        return http.get(`api/ReviewExternal/${id}/${entity}/Report`);
    }
    getAllReports(id: number, exid: number, entity: string): any {
        return http.get(`api/ReviewExternal/${entity}/${exid}/${id}/AllReport`);
    }

    /** method to get review summary of an application */
    getReviewSummary(id: number, entity: string): any {
        var queryObj: any = {};

        queryObj.fields = ["applicationId", "coiActionDate", "comment", "totalScore", "recommendation", "reviewerId"];
        queryObj.size = 100;
        queryObj.filter = [
            {
                "id": "applicationId",
                "operator": "and",
                "parent": "",
                "nested": false,
                "type": "integer",
                "value": [id]
            }
        ];
        queryObj.aggregate = [];

        queryObj.sort = [];

        return http.post(`api/ReviewExternal/Summary/${id}/${entity}`, queryObj)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        }).catch(e => {
            return e.response;
        });

    }

    /** method to update the review */
    updateReviewData(entity: string, id: number, review: any): any {
        return http.put(`api/ReviewExternal/${entity}/${id}`, review)
            .then((resp: any) => {
                return resp.data;
            })
    }

    /** method to save */
    saveReviewData(review: any): any {
        const entity = review.entity;
        return http.post(`api/ReviewExternal/${entity}`, review)
            .then((resp: any) => {
                return resp.data;
            });
    }

    /** Submit review data */
    submitReviewData(entity: string, id: number, review: any): any {
        return http.put(`api/ReviewExternal/submit/${entity}/${id}`, review)
            .then((resp: any) => {
                return resp.data;
            })
    }


    /** Method to dis agree COI */
    disAgreeCOI(review: any): any {
        const entity = review.entity;
        return http.post(`api/ReviewExternal/DisagreeCOI/${entity}`, review)
            .then((resp: any) => {
                return resp.data;
            });
    }

    /** external reviewer dashboard listing */
    listProposals(entity: string): any {
        return http.get(`/api/ReviewExternal/${entity}/List`).then((resp: any) => {
            if (resp.data && resp.data.Items) {
                return resp.data.Items;
            } else {
                return [];
            }
        });
    }

    getApplicationInfo(id: number, entity: string): any {
        return http.get(`/api/ReviewExternal/AppInfo/${entity}/${id}`).then((resp: any) => {
            if (resp.data) {
                return resp.data;
            } else {
                return {};
            }
        });
    }

    /** method to rollback the review - IUCN Admin should be able to return a review to a reviewer when needed */
    rollbackReview(id: any, reason: any): any {
        return http.put(`api/ReviewExternal/RollbackReview/${id}/${reason}`, id, reason).then((resp: any) => {
                return resp.data;
        });
    }
}